import getStarVariant from './helpers/get-star-variant'
import Star from './Star'

const MAX_STARS = 5
interface Props {
  venueId: string
  rating?: number | null
  size?: 'regular' | 'small'
}

const StarRating = ({ venueId, rating = 0, size = 'regular' }: Props) => {
  const stars = Array.from(Array(MAX_STARS))
  const roundedRating = Number((rating || 0).toFixed(1))
  return (
    <div className="flex">
      {stars.map((_, idx) => (
        <Star key={`star-${idx}-${venueId}`} variant={getStarVariant(roundedRating - idx)} size={size} />
      ))}
    </div>
  )
}

export default StarRating
